module.exports = __webpack_public_path__ + "static/media/callCenter.dd14ec7d.svg";